// import React, { useState } from "react";

// export default function Register() {
//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     password: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const onSubmit = (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     setTimeout(() => {
//       if (!form.name || !form.phone || !form.email || !form.password) {
//         setError("Please fill all fields");
//         setLoading(false);
//         return;
//       }

//       console.log("Registered user:", form);
//       setLoading(false);
//       alert("Registration successful!");
//     }, 800);
//   };

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   return (
//     <div className="w-full flex items-center justify-center bg-white p-6 text-black">
//       <div className="w-full max-w-6xl  rounded-xl  overflow-hidden grid grid-cols-1 md:grid-cols-2 min-h-[70vh]">

//         {/* LEFT IMAGE */}
//     <div className="w-full h-48 md:h-full mt-14">

//           <img src="/111.jpg" alt="Register" className="w-full h-full object-cover" />
//         </div>

//         {/* RIGHT FORM */}
//         <div className="p-8 md:p-12 flex items-center justify-center">
//           <div className="w-full max-w-md">
//             <h2 className="text-3xl font-bold mb-2 text-brandPink">
//               Create Account
//             </h2>
//             <p className="text-sm mb-6">Fill in your details to continue.</p>

//             <form onSubmit={onSubmit} className="space-y-4">

//               {/* FULL NAME */}
//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   Full name
//                 </label>
//                 <input
//                   name="name"
//                   placeholder="John Doe"
//                   className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#1C7C2C] outline-none"
//                   value={form.name}
//                   onChange={handleChange}
//                 />
//               </div>

//               {/* PHONE */}
//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   Phone number
//                 </label>
//                 <input
//                   name="phone"
//                   placeholder="+91 98765 43210"
//                   className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#1C7C2C] outline-none"
//                   value={form.phone}
//                   onChange={handleChange}
//                 />
//               </div>

//               {/* EMAIL */}
//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   Email address
//                 </label>
//                 <input
//                   type="email"
//                   name="email"
//                   placeholder="you@example.com"
//                   className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#1C7C2C] outline-none"
//                   value={form.email}
//                   onChange={handleChange}
//                 />
//               </div>

//               {/* PASSWORD */}
//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   Password
//                 </label>
//                 <input
//                   type="password"
//                   name="password"
//                   placeholder="••••••••"
//                   className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#1C7C2C] outline-none"
//                   value={form.password}
//                   onChange={handleChange}
//                 />
//               </div>

//               {error && <p className="text-red-500 text-sm">{error}</p>}

//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="w-full text-white font-semibold py-2 rounded-lg transition bg-brandPurple hover:opacity-90"
//               >
//                 {loading ? "Creating account..." : "Register"}
//               </button>
//             </form>

//             <p className="mt-6 text-sm">
//               Already have an account?{" "}
//               <a href="/login" className="font-medium text-brandPurple">
//                 Sign in
//               </a>
//             </p>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// }









import React, { useState } from "react";
import { AuthAPI } from "../api/AuthAPI";
import { useNavigate } from "react-router-dom";

export default function Register() {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
const [phoneError, setPhoneError] = useState("");
const isValidPhone = (phone) => /^[0-9]{10}$/.test(phone);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!form.name || !form.phone || !form.email || !form.password) {
      setError("Please fill all fields");
      return;
    }

    setLoading(true);

    try {
      await AuthAPI.signup({
        name: form.name,
        email: form.email,
        password: form.password,
        phone: form.phone,
      });

      alert("Registration successful!");
      navigate("/");
    } catch (err) {
      setError(
        err.response?.data?.message || "Registration failed. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full flex items-center justify-center bg-white p-6 text-black">
      <div className="w-full max-w-6xl rounded-xl overflow-hidden grid grid-cols-1 md:grid-cols-2 min-h-[70vh]">

        {/* LEFT IMAGE */}
        <div className="w-full h-48 md:h-full mt-14">
          <img
            src="/111.jpg"
            alt="Register"
            className="w-full h-full object-cover"
          />
        </div>

        {/* RIGHT FORM */}
        <div className="p-8 md:p-12 flex items-center justify-center">
          <div className="w-full max-w-md">
            <h2 className="text-3xl font-bold mb-2 text-brandPink">
              Create Account
            </h2>
            <p className="text-sm mb-6">
              Fill in your details to continue.
            </p>

            <form onSubmit={onSubmit} className="space-y-4">

              {/* FULL NAME */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Full name
                </label>
                <input
                  name="name"
                  placeholder="John Doe"
                  className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#1C7C2C] outline-none"
                  value={form.name}
                  onChange={handleChange}
                />
              </div>

              {/* PHONE */}
          <div>
  <label className="block text-sm font-medium mb-1">
    Phone number
  </label>

  <input
    name="phone"
    placeholder="9876543210"
    maxLength={10}
    className={`w-full border rounded-lg px-3 py-2 focus:ring-2 outline-none
      ${phoneError ? "border-red-500 focus:ring-red-300" : "focus:ring-[#1C7C2C]"}
    `}
    value={form.phone}
    onChange={(e) => {
      const value = e.target.value.replace(/\D/g, ""); // 🔒 digits only

      setForm({ ...form, phone: value });

      if (value.length === 0) {
        setPhoneError("");
      } else if (!isValidPhone(value)) {
        setPhoneError("Phone number must be exactly 10 digits");
      } else {
        setPhoneError("");
      }
    }}
  />

  {phoneError && (
    <p className="text-xs text-red-500 mt-1">
      {phoneError}
    </p>
  )}
</div>


              {/* EMAIL */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Email address
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#1C7C2C] outline-none"
                  value={form.email}
                  onChange={handleChange}
                />
              </div>

              {/* PASSWORD */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Password
                </label>
                <input
                  type="password"
                  name="password"
                  placeholder="••••••••"
                  className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#1C7C2C] outline-none"
                  value={form.password}
                  onChange={handleChange}
                />
              </div>

              {error && (
                <p className="text-red-500 text-sm">{error}</p>
              )}

              <button
                type="submit"
                disabled={loading}
                className="w-full text-white font-semibold py-2 rounded-lg transition bg-brandPurple hover:opacity-90"
              >
                {loading ? "Creating account..." : "Register"}
              </button>
            </form>

            <p className="mt-6 text-sm">
              Already have an account?{" "}
              <a href="/" className="font-medium text-brandPurple">
                Sign in
              </a>
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}
